/* eslint-disable indent */
//#region Imports

import { isNullOrEmpty } from '../../assets/js/function-utils';
import { RECTANGLE_STATUS_COLOR } from '../../consts/rectangle-color';
import DADOS_SIM from './../../consts/consts';
import ENUM from './../../consts/enum';
import SessionService from './../../session/session-service';

const listaBemValues = DADOS_SIM.LISTA_BENS;
const dadosClienteValues = DADOS_SIM.DADOS_CLIENTE;
const enderecoValues = DADOS_SIM.ENDERECO;
const beneficiarioValues = DADOS_SIM.BENEFICIARIOS;
const detalhesEquipamentoValues = DADOS_SIM.DETALHES_EQUIPAMENTOS;
const coCorretagemValues = DADOS_SIM.COCORRETAGEM;
const pagamentoValues = DADOS_SIM.PAGAMENTO;
const geoFields = DADOS_SIM.GEOLOCALIZACAO;

//#endregion

/**
 * Types
 */

export const DadosComplementaresTypes = {
    POPULATE_DADOS_COMPLEMENTARES_FROM_STORAGE: 'dadosComplementares/POPULATE_DADOS_COMPLEMENTARES_FROM_STORAGE',
    SEND_DADOS_CONTATO: 'dadosComplementares/SEND_DADOS_CONTATO',
    SEND_DADOS_CO_CORRETAGEM: 'dadosComplementares/SEND_DADOS_CO_CORRETAGEM',
    SEND_DADOS_FORMAPAGAMENTO: 'dadosComplementares/SEND_DADOS_FORMAPAGAMENTO',
    SET_LISTA_ERROS: 'dadosComplementares/SET_LISTA_ERROS',
    REMOVE_ERROS: 'dadosComplementares/REMOVE_ERROS',
    SET_ENDERECO_BEM: 'dadosComplementares/SET_ENDERECO_BEM',
    SET_BENEFICIARIO_BEM: 'dadosComplementares/SET_BENEFICIARIO_BEM',
    DELETE_BENEFICIARIO_BEM: 'dadosComplementares/DELETE_BENEFICIARIO_BEM',
    SET_LMI_BENEFICIARIO: 'dadosComplementares/SET_LMI_BENEFICIARIO',
    SET_DETALHES_EQUIPAMENTOS: 'dadosComplementares/SET_DETALHES_EQUIPAMENTOS',
    UPDATE_POLYGON_BEM: 'dadosComplementares/UPDATE_POLYGON_BEM',
    ADD_KML: 'dadosComplementares/ADD_KML',
    UPDATE_COORD_BEM: 'dadosComplementares/UPDATE_COORD_BEM',
    SEND_DADOS_COMPLEMENTARES_RESET: 'dadosComplementares/SEND_DADOS_COMPLEMENTARES_RESET',
    SEND_DADOS_COMPLEMENTARES: 'dadosComplementares/SEND_DADOS_COMPLEMENTARES',
    SEND_DADOS_COMPLEMENTARES_SUCCESS: 'dadosComplementares/SEND_DADOS_COMPLEMENTARES_SUCCESS',
    SEND_DADOS_COMPLEMENTARES_FAILURE: 'dadosComplementares/SEND_DADOS_COMPLEMENTARES_FAILURE',
    ERROR_MODAL_ENDERECO_BENEFICIARIOS: 'dadosComplementares/SHOW_ERROR_MODAL_ENDERECO_BENEFICIARIOS',
    VERIFICA_PREENCHIMENTO_CAMPOS_BEM: 'dadosComplementares/VERIFICA_PREENCHIMENTO_CAMPOS_BEM',
    VERIFICA_PREENCHIMENTO_TODOS_BENS: 'dadosComplementares/VERIFICA_PREENCHIMENTO_TODOS_BENS',
    SET_FORMA_PAGAMENTO: 'dadosComplementares/SET_FORMA_PAGAMENTO',
    RESET_FORMA_PAGAMENTO: 'dadosComplementares/RESET_FORMA_PAGAMENTO',
    RESET: 'dadosComplementares/RESET',
    UPDATE_STATE_BUTTON_DESENHAR: 'dadosComplementares/UPDATE_STATE_BUTTON_DESENHAR',
    VINCULA_BENEFICIARIOS_AOS_BENS: 'dadosComplementares/VINCULA_BENEFICIARIOS_AOS_BENS',
    SET_DADOS_CO_CORRETAGEM: 'dadosComplementares/SET_DADOS_CO_CORRETAGEM',
    SET_DADOS_POLIGONOS: 'dadosComplementares/SET_DADOS_POLIGONOS',
    SET_DADOS_FIDUCIARIOS: 'dadosComplementares/SET_DADOS_FIDUCIARIOS',
    SET_COMBO_PARCELAMENTO: 'dadosComplementares/SET_COMBO_PARCELAMENTO'
};

/**
 * Reducer
 */

const INITIAL_STATE = {
    listaBensGarantia: [],
    listaBensNaoGarantia: [],
    listErros: [],
    [listaBemValues.PREENCHIMENTO_TODOS_BENS]: false,
    errorModalEnderecoBeneficiarios: {
        show: false,
        title: null,
        message: null
    }
};

const retangleRed = {
    position: 'absolute',
    left: 0,
    width: 10,
    height: 54,
    alignItems: 'flex-start',
    backgroundColor: RECTANGLE_STATUS_COLOR.LARANJA
};
const retangleGreen = {
    position: 'absolute',
    left: 0,
    width: 10,
    height: 54,
    alignItems: 'flex-start',
    backgroundColor: RECTANGLE_STATUS_COLOR.VERDE
};

function adicionaBeneficiarioBem(listaBens, idBem, dados) {
    try {
        return listaBens.map((bem) => {
            if (bem.id !== idBem) {
                return bem;
            }

            return (bem = {
                ...bem,
                [beneficiarioValues.THIS]: [...bem[beneficiarioValues.THIS], dados]
            });
        });
    } catch (error) {
        console.error('Erro ao adicionar um beneficiario ao bem, adicionaBeneficiarioBem(listaBens, idBem, dados)');
        throw error;
    }
}

function adicionaEnderecoBem(listaBens, idBem, dados) {
    try {
        return listaBens.map((bem) => {
            if (bem.id !== idBem) {
                return bem;
            }
            return {
                ...bem,
                [enderecoValues.ID_ENDERECO]: dados
            };
        });
    } catch (error) {
        console.error('Erro ao adicionar um endereco ao bem, adicionaEnderecoBem(listaBens, idBem, dados)');
        throw error;
    }
}

function removeBeneficiarioBem(listaBens, idBem, idBeneficiario) {
    try {
        return listaBens.map((bem) => {
            if (bem.id !== idBem) {
                return bem;
            }
            return {
                ...bem,
                [beneficiarioValues.THIS]: bem[beneficiarioValues.THIS].filter((beneficiario) => {
                    return beneficiario[beneficiarioValues.ID_BENEFICIARIO] !== idBeneficiario;
                })
            };
        });
    } catch (error) {
        console.error(
            'Erro ao remover um beneficiario do bem, removeBeneficiarioBem(listaBens, idBem, idBeneficiario)'
        );
        throw error;
    }
}

function setLMIBeneficiario(listaBens, idBem, idBeneficiario, dados) {
    try {
        return listaBens.map((bem) => {
            if (bem.id !== idBem) {
                return bem;
            }
            return {
                ...bem,
                [beneficiarioValues.THIS]: bem[beneficiarioValues.THIS].map((beneficiario) => {
                    if (beneficiario[beneficiarioValues.ID_BENEFICIARIO] !== idBeneficiario) {
                        return beneficiario;
                    }

                    return (beneficiario = {
                        ...beneficiario,
                        [beneficiarioValues.VALOR_LMI]: dados
                    });
                })
            };
        });
    } catch (error) {
        console.error(
            'Erro ao atribuir LMI ao beneficiario, setLMIBeneficiario(listaBens,idBem, idBeneficiario, dados)'
        );
        throw error;
    }
}

function setDetalhesEquipamento(listaBens, idBem, fabricante, modelo, chassi) {
    try {
        return listaBens.map((bem) => {
            if (bem.id !== idBem) {
                return bem;
            }
            return {
                ...bem,
                [detalhesEquipamentoValues.FABRICANTE]: fabricante,
                [detalhesEquipamentoValues.MODELO]: modelo,
                [detalhesEquipamentoValues.CHASSI]: chassi
            };
        });
    } catch (error) {
        console.error('Erro ao atribuir detalhes do equipamento, setDetalhesEquipamento(listaBens,idBem, dados)');
        throw error;
    }
}

function removePoligonoAndKmlFromListBens(listaBens) {
    return (
        listaBens &&
        listaBens.map((e) => ({
            ...e,
            [listaBemValues.KML]: null,
            [listaBemValues.POLIGONOS]: []
        }))
    );
}

function setDadosSession(listaBens, inGarantia) {
    let objSession = SessionService.getSession();
    if (inGarantia) {
        SessionService.setSession({
            ...objSession,
            listaBensGarantia: removePoligonoAndKmlFromListBens(listaBens)
        });
    } else {
        SessionService.setSession({
            ...objSession,
            listaBensNaoGarantia: removePoligonoAndKmlFromListBens(listaBens)
        });
    }
}

// libera botão de "Avançar" na tela de dados complementares
function verificaPreenchimentoCamposBem(listaBens, idBem) {
    return listaBens.map((bem) => {
        if (bem.id !== idBem) {
            return bem;
        }

        let somaLMI = bem[beneficiarioValues.THIS].reduce((total, beneficiario) => {
            return (total += beneficiario[beneficiarioValues.VALOR_LMI]);
        }, 0);

        let detalhesEquip = true;

        if (
            bem[listaBemValues.ID_TIPO_BEM] === ENUM.TIPO_BEM.EQUIPAMENTOS_ESTACIONARIOS ||
            bem[listaBemValues.ID_TIPO_BEM] === ENUM.TIPO_BEM.EQUIPAMENTOS_MOVEIS
        ) {
            const fabricante = bem[detalhesEquipamentoValues.FABRICANTE];
            const modelo = bem[detalhesEquipamentoValues.MODELO];
            const chassi = bem[detalhesEquipamentoValues.CHASSI];

            if (!fabricante || !modelo || !chassi) {
                detalhesEquip = false;
            }

            if (chassi && chassi.length > 17) {
                detalhesEquip = false;
            }
        }

        const qtdCoord = bem.coordenadas
            ? Object.values(bem.coordenadas.latitude).concat(Object.values(bem.coordenadas.longitude))
            : [];
        const qtdFiltered = qtdCoord.filter((value) => !isNullOrEmpty(value));

        const camposPreenchidos =
            (qtdFiltered.length === 0 || qtdFiltered.length === 8) &&
            detalhesEquip &&
            somaLMI === 100 &&
            !isNullOrEmpty(bem[enderecoValues.ID_ENDERECO]) &&
            bem[enderecoValues.ID_ENDERECO] !== 0;

        return {
            ...bem,
            [listaBemValues.CAMPOS_PREENCHIDOS]: camposPreenchidos,
            [listaBemValues.RETANGULO_DADOS_COMPLEMENTARES]: camposPreenchidos ? retangleGreen : retangleRed
        };
    });
}

function verificaPreenchimentoBens(listaBensGarantia, listaBensNaoGarantia) {
    let existeBemNaoPreenchido;
    existeBemNaoPreenchido = listaBensGarantia.find((bem) => bem[listaBemValues.CAMPOS_PREENCHIDOS] === false);
    existeBemNaoPreenchido += listaBensNaoGarantia.find((bem) => bem[listaBemValues.CAMPOS_PREENCHIDOS] === false);

    if (existeBemNaoPreenchido) return false;
    else return true;
}

function setBeneficiarioBemFromApi(listaBeneficiarios, listaBens) {
    if (listaBeneficiarios && listaBeneficiarios.length > 0) {
        const newListaBens =
            listaBens &&
            listaBens.map((bem) => {
                const listaBeneficiariosBem = bem[beneficiarioValues.THIS];

                let filteredListaBeneficiariosToAdd = listaBeneficiarios.map((benefToAdd) => {
                    let isBenefAlreadyAdded = false;

                    listaBeneficiariosBem &&
                        listaBeneficiariosBem.forEach((bemBeneficiario) => {
                            if (
                                bemBeneficiario[beneficiarioValues.ID_BENEFICIARIO] ===
                                    benefToAdd[beneficiarioValues.ID_BENEFICIARIO] &&
                                !isNullOrEmpty(benefToAdd[beneficiarioValues.VALOR_LMI])
                            ) {
                                isBenefAlreadyAdded = true;
                            }
                        });

                    if (!isBenefAlreadyAdded && benefToAdd[beneficiarioValues.VALOR_LMI] > 0)
                        return {
                            [beneficiarioValues.ID_BENEFICIARIO]: benefToAdd[beneficiarioValues.ID_BENEFICIARIO],
                            [beneficiarioValues.VALOR_LMI]: benefToAdd[beneficiarioValues.VALOR_LMI]
                        };
                    else return null;
                });

                filteredListaBeneficiariosToAdd = filteredListaBeneficiariosToAdd.filter((el) => el);

                return {
                    ...bem,
                    [beneficiarioValues.THIS]: [...bem[beneficiarioValues.THIS], ...filteredListaBeneficiariosToAdd]
                };
            });

        return newListaBens;
    } else {
        return listaBens;
    }
}

export function dadosComplementaresReducer(state = INITIAL_STATE, action) {
    switch (action.type) {
        case DadosComplementaresTypes.POPULATE_DADOS_COMPLEMENTARES_FROM_STORAGE: {
            const session = SessionService.getSession();
            const { listaBensRetorno, listaBensGarantia, listaBensNaoGarantia, dadosContato } = session;
            const dadosFormaPagamento = session[pagamentoValues.THIS];

            let nextListaBensGarantia;
            let nextListaBensNaoGarantia;
            let nextDadosFormaPagamento;
            let nextDadosContato;

            if (session && listaBensGarantia) {
                nextListaBensGarantia = listaBensGarantia;
            } else {
                nextListaBensGarantia = listaBensRetorno.filter((bem) => bem[listaBemValues.GARANTIA]);
            }
            if (session && listaBensNaoGarantia) {
                nextListaBensNaoGarantia = listaBensNaoGarantia;
            } else {
                nextListaBensNaoGarantia = listaBensRetorno.filter((bem) => !bem[listaBemValues.GARANTIA]);
            }
            if (session && dadosFormaPagamento) {
                nextDadosFormaPagamento = dadosFormaPagamento;
            }
            if (session && dadosContato) {
                nextDadosContato = dadosContato;
            }

            return {
                ...state,
                [listaBemValues.PREENCHIMENTO_TODOS_BENS]: session[listaBemValues.PREENCHIMENTO_TODOS_BENS],
                listaBensGarantia: nextListaBensGarantia,
                listaBensNaoGarantia: nextListaBensNaoGarantia,
                dadosContato: nextDadosContato,
                [pagamentoValues.THIS]: nextDadosFormaPagamento,
                listErros: []
            };
        }
        case DadosComplementaresTypes.RESET: {
            return { state: [] };
        }
        case DadosComplementaresTypes.SEND_DADOS_CONTATO: {
            SessionService.setSession({
                dadosContato: {
                    ...state.dadosContato,
                    [dadosClienteValues.EMAIL_ADICIONAL]: action.payload.dadosForm[dadosClienteValues.EMAIL_ADICIONAL],
                    [dadosClienteValues.TELEFONE_ADICIONAL]:
                        action.payload.dadosForm[dadosClienteValues.TELEFONE_ADICIONAL],
                    [dadosClienteValues.EMAIL_SOLICITANTE]:
                        action.payload.dadosForm[dadosClienteValues.EMAIL_SOLICITANTE]
                }
            });

            return {
                ...state,
                dadosContato: {
                    ...state.dadosContato,
                    [dadosClienteValues.EMAIL_ADICIONAL]: action.payload.dadosForm[dadosClienteValues.EMAIL_ADICIONAL],
                    [dadosClienteValues.TELEFONE_ADICIONAL]:
                        action.payload.dadosForm[dadosClienteValues.TELEFONE_ADICIONAL],
                    [dadosClienteValues.EMAIL_SOLICITANTE]:
                        action.payload.dadosForm[dadosClienteValues.EMAIL_SOLICITANTE]
                }
            };
        }
        case DadosComplementaresTypes.SEND_DADOS_CO_CORRETAGEM: {
            SessionService.setSession({
                [coCorretagemValues.THIS]: {
                    ...state[coCorretagemValues.THIS],
                    [coCorretagemValues.NOME_CORRETORA1]: action.payload.dadosForm[coCorretagemValues.NOME_CORRETORA1],
                    [coCorretagemValues.CNPJ_CORRETORA1]: action.payload.dadosForm[coCorretagemValues.CNPJ_CORRETORA1],
                    [coCorretagemValues.NOME_CORRETORA2]: action.payload.dadosForm[coCorretagemValues.NOME_CORRETORA2],
                    [coCorretagemValues.CNPJ_CORRETORA2]: action.payload.dadosForm[coCorretagemValues.CNPJ_CORRETORA2],
                    [coCorretagemValues.NOME_CORRETORA3]: action.payload.dadosForm[coCorretagemValues.NOME_CORRETORA3],
                    [coCorretagemValues.CNPJ_CORRETORA3]: action.payload.dadosForm[coCorretagemValues.CNPJ_CORRETORA3]
                }
            });
            return {
                ...state,
                [coCorretagemValues.THIS]: {
                    ...state[coCorretagemValues.THIS],
                    [coCorretagemValues.NOME_CORRETORA1]: action.payload.dadosForm[coCorretagemValues.NOME_CORRETORA1],
                    [coCorretagemValues.CNPJ_CORRETORA1]: action.payload.dadosForm[coCorretagemValues.CNPJ_CORRETORA1],
                    [coCorretagemValues.NOME_CORRETORA2]: action.payload.dadosForm[coCorretagemValues.NOME_CORRETORA2],
                    [coCorretagemValues.CNPJ_CORRETORA2]: action.payload.dadosForm[coCorretagemValues.CNPJ_CORRETORA2],
                    [coCorretagemValues.NOME_CORRETORA3]: action.payload.dadosForm[coCorretagemValues.NOME_CORRETORA3],
                    [coCorretagemValues.CNPJ_CORRETORA3]: action.payload.dadosForm[coCorretagemValues.CNPJ_CORRETORA3]
                }
            };
        }
        case DadosComplementaresTypes.SEND_DADOS_FORMAPAGAMENTO: {
            SessionService.setSession({
                [pagamentoValues.THIS]: {
                    ...state[pagamentoValues.THIS],
                    [pagamentoValues.NUMERO_AGENCIA]: action.payload.dadosForm[pagamentoValues.NUMERO_AGENCIA],
                    [pagamentoValues.DIA_VENCIMENTO]: action.payload.dadosForm[pagamentoValues.DIA_VENCIMENTO],
                    [pagamentoValues.DIGITO_AGENCIA]: action.payload.dadosForm[pagamentoValues.DIGITO_AGENCIA],
                    [pagamentoValues.CONTA_BB]: action.payload.dadosForm[pagamentoValues.CONTA_BB],
                    [pagamentoValues.DIGITO_CONTA]: action.payload.dadosForm[pagamentoValues.DIGITO_CONTA],
                    [pagamentoValues.FORMA_PAGAMENTO]: action.payload.dadosForm[pagamentoValues.FORMA_PAGAMENTO]
                }
            });
            return {
                ...state,
                [pagamentoValues.THIS]: {
                    ...state[pagamentoValues.THIS],
                    [pagamentoValues.NUMERO_AGENCIA]: action.payload.dadosForm[pagamentoValues.NUMERO_AGENCIA],
                    [pagamentoValues.DIA_VENCIMENTO]: action.payload.dadosForm[pagamentoValues.DIA_VENCIMENTO],
                    [pagamentoValues.DIGITO_AGENCIA]: action.payload.dadosForm[pagamentoValues.DIGITO_AGENCIA],
                    [pagamentoValues.CONTA_BB]: action.payload.dadosForm[pagamentoValues.CONTA_BB],
                    [pagamentoValues.DIGITO_CONTA]: action.payload.dadosForm[pagamentoValues.DIGITO_CONTA],
                    [pagamentoValues.FORMA_PAGAMENTO]: action.payload.dadosForm[pagamentoValues.FORMA_PAGAMENTO]
                }
            };
        }
        case DadosComplementaresTypes.SET_FORMA_PAGAMENTO: {
            SessionService.setSession({
                [pagamentoValues.THIS]: {
                    ...state[pagamentoValues.THIS],
                    [pagamentoValues.FORMA_PAGAMENTO]: action.payload[pagamentoValues.FORMA_PAGAMENTO]
                }
            });
            return {
                ...state,
                [pagamentoValues.THIS]: {
                    ...state[pagamentoValues.THIS],
                    [pagamentoValues.FORMA_PAGAMENTO]: action.payload[pagamentoValues.FORMA_PAGAMENTO]
                }
            };
        }
        case DadosComplementaresTypes.RESET_FORMA_PAGAMENTO: {
            SessionService.setSession({
                [pagamentoValues.THIS]: null
            });
            return {
                ...state,
                [pagamentoValues.THIS]: null
            };
        }
        case DadosComplementaresTypes.SET_LISTA_ERROS: {
            return {
                ...state,
                listErros: state.listErros.concat(action.payload.listErros),
                showModalError: action.payload.showModalError
            };
        }
        case DadosComplementaresTypes.REMOVE_ERROS: {
            return { ...state, listErros: [], showModalError: false };
        }
        case DadosComplementaresTypes.SET_ENDERECO_BEM: {
            if (action.payload.isGarantia) {
                const nextListaBensGarantia = adicionaEnderecoBem(
                    state.listaBensGarantia,
                    action.payload[listaBemValues.ID_BEM],
                    action.payload[enderecoValues.ID_ENDERECO]
                );
                setDadosSession(nextListaBensGarantia, true);
                return {
                    ...state,
                    listaBensGarantia: nextListaBensGarantia
                };
            } else {
                const nextListaBensNaoGarantia = adicionaEnderecoBem(
                    state.listaBensNaoGarantia,
                    action.payload[listaBemValues.ID_BEM],
                    action.payload[enderecoValues.ID_ENDERECO]
                );
                setDadosSession(nextListaBensNaoGarantia, false);
                return {
                    ...state,
                    listaBensNaoGarantia: nextListaBensNaoGarantia
                };
            }
        }
        case DadosComplementaresTypes.SET_BENEFICIARIO_BEM: {
            const objBeneficiario = {
                idBeneficiario: action.payload[beneficiarioValues.ID_BENEFICIARIO],
                valueLMI: action.payload[beneficiarioValues.VALOR_LMI]
            };

            if (action.payload.isGarantia) {
                const nextListaBensGarantia = adicionaBeneficiarioBem(
                    state.listaBensGarantia,
                    action.payload[listaBemValues.ID_BEM],
                    objBeneficiario
                );

                setDadosSession(nextListaBensGarantia, true);

                return {
                    ...state,
                    listaBensGarantia: nextListaBensGarantia
                };
            } else {
                const nextListaBensNaoGarantia = adicionaBeneficiarioBem(
                    state.listaBensNaoGarantia,
                    action.payload[listaBemValues.ID_BEM],
                    objBeneficiario
                );
                setDadosSession(nextListaBensNaoGarantia, false);

                return {
                    ...state,
                    listaBensNaoGarantia: nextListaBensNaoGarantia
                };
            }
        }
        case DadosComplementaresTypes.DELETE_BENEFICIARIO_BEM: {
            if (action.payload.isGarantia) {
                const nextListaBensGarantia = removeBeneficiarioBem(
                    state.listaBensGarantia,
                    action.payload[listaBemValues.ID_BEM],
                    action.payload[beneficiarioValues.ID_BENEFICIARIO]
                );
                setDadosSession(nextListaBensGarantia, true);

                return {
                    ...state,
                    listaBensGarantia: nextListaBensGarantia
                };
            } else {
                const nextListaBensNaoGarantia = removeBeneficiarioBem(
                    state.listaBensNaoGarantia,
                    action.payload[listaBemValues.ID_BEM],
                    action.payload[beneficiarioValues.ID_BENEFICIARIO]
                );
                setDadosSession(nextListaBensNaoGarantia, false);

                return {
                    ...state,
                    listaBensNaoGarantia: nextListaBensNaoGarantia
                };
            }
        }
        case DadosComplementaresTypes.SET_LMI_BENEFICIARIO: {
            if (action.payload.isGarantia) {
                const nextListaBensGarantia = setLMIBeneficiario(
                    state.listaBensGarantia,
                    action.payload[listaBemValues.ID_BEM],
                    action.payload[beneficiarioValues.ID_BENEFICIARIO],
                    action.payload[beneficiarioValues.VALOR_LMI]
                );
                setDadosSession(nextListaBensGarantia, true);
                return {
                    ...state,
                    listaBensGarantia: nextListaBensGarantia
                };
            } else {
                const nextListaBensNaoGarantia = setLMIBeneficiario(
                    state.listaBensNaoGarantia,
                    action.payload[listaBemValues.ID_BEM],
                    action.payload[beneficiarioValues.ID_BENEFICIARIO],
                    action.payload[beneficiarioValues.VALOR_LMI]
                );
                setDadosSession(nextListaBensNaoGarantia, false);

                return {
                    ...state,
                    listaBensNaoGarantia: nextListaBensNaoGarantia
                };
            }
        }
        case DadosComplementaresTypes.SET_DETALHES_EQUIPAMENTOS: {
            if (action.payload.isGarantia) {
                const nextListaBensGarantia = setDetalhesEquipamento(
                    state.listaBensGarantia,
                    action.payload[listaBemValues.ID_BEM],
                    action.payload[detalhesEquipamentoValues.FABRICANTE],
                    action.payload[detalhesEquipamentoValues.MODELO],
                    action.payload[detalhesEquipamentoValues.CHASSI]
                );
                setDadosSession(nextListaBensGarantia, true);

                return {
                    ...state,
                    listaBensGarantia: nextListaBensGarantia
                };
            } else {
                const nextListaBensNaoGarantia = setDetalhesEquipamento(
                    state.listaBensNaoGarantia,
                    action.payload[listaBemValues.ID_BEM],
                    action.payload[detalhesEquipamentoValues.FABRICANTE],
                    action.payload[detalhesEquipamentoValues.MODELO],
                    action.payload[detalhesEquipamentoValues.CHASSI]
                );
                setDadosSession(nextListaBensNaoGarantia, false);
                return {
                    ...state,
                    listaBensNaoGarantia: nextListaBensNaoGarantia
                };
            }
        }

        case DadosComplementaresTypes.SET_DADOS_FIDUCIARIOS: {
            const { id, numContratoFiduciario, instituicao, cnpj } = action.payload;

            const newListaBensGarantia = state.listaBensGarantia.map((bem) => {
                if (bem.id === id) {
                    return {
                        ...bem,
                        numContratoFiduciario,
                        instituicao,
                        cnpj
                    };
                }

                return bem;
            });

            setDadosSession(newListaBensGarantia, true);

            return {
                ...state,
                listaBensGarantia: newListaBensGarantia
            };
        }

        case DadosComplementaresTypes.UPDATE_POLYGON_BEM:
            if (action.payload.isGarantia) {
                return {
                    ...state,
                    listaBensGarantia: state.listaBensGarantia.map((bem) => {
                        if (bem.id === action.payload[listaBemValues.ID_BEM]) {
                            return {
                                ...bem,
                                poligonos: action.payload.poligonos
                            };
                        }

                        return bem;
                    })
                };
            } else {
                return {
                    ...state,
                    listaBensNaoGarantia: state.listaBensNaoGarantia.map((bem) => {
                        if (bem.id === action.payload[listaBemValues.ID_BEM]) {
                            return {
                                ...bem,
                                poligonos: action.payload.poligonos
                            };
                        }

                        return bem;
                    })
                };
            }
        case DadosComplementaresTypes.ADD_KML:
            if (action.payload.isGarantia) {
                return {
                    ...state,
                    listaBensGarantia: state.listaBensGarantia.map((bem) => {
                        if (bem.id === action.payload[listaBemValues.ID_BEM]) {
                            return {
                                ...bem,
                                [listaBemValues.KML]: action.payload.kml,
                                [listaBemValues.HAS_KML]: action.payload.kml ? true : false
                            };
                        }
                        return bem;
                    })
                };
            } else {
                return {
                    ...state,
                    listaBensNaoGarantia: state.listaBensNaoGarantia.map((bem) => {
                        if (bem.id === action.payload[listaBemValues.ID_BEM]) {
                            return {
                                ...bem,
                                [listaBemValues.KML]: action.payload.kml,
                                [listaBemValues.HAS_KML]: action.payload.kml ? true : false
                            };
                        }
                        return bem;
                    })
                };
            }

        case DadosComplementaresTypes.UPDATE_COORD_BEM: {
            if (action.payload.isGarantia) {
                const nextListaBensGarantia = state.listaBensGarantia.map((bem) => {
                    if (bem.id === action.payload[listaBemValues.ID_BEM]) {
                        return {
                            ...bem,
                            coordenadas: action.payload.coordenadas
                        };
                    }
                    return bem;
                });

                return {
                    ...state,
                    listaBensGarantia: verificaPreenchimentoCamposBem(
                        nextListaBensGarantia,
                        action.payload[listaBemValues.ID_BEM]
                    )
                };
            } else {
                const nextListaBensNaoGarantia = state.listaBensNaoGarantia.map((bem) => {
                    if (bem.id === action.payload[listaBemValues.ID_BEM]) {
                        return {
                            ...bem,
                            coordenadas: action.payload.coordenadas
                        };
                    }
                    return bem;
                });

                return {
                    ...state,
                    listaBensNaoGarantia: verificaPreenchimentoCamposBem(
                        nextListaBensNaoGarantia,
                        action.payload[listaBemValues.ID_BEM]
                    )
                };
            }
        }
        case DadosComplementaresTypes.SEND_DADOS_COMPLEMENTARES_RESET:
            return {
                ...state,
                msgErroSaveDadosComplementares: '',
                saveDadosComplementaresSuccess: false,
                loadingTelaDadosComplementares: false
            };
        case DadosComplementaresTypes.SEND_DADOS_COMPLEMENTARES:
            return {
                ...state,
                loadingTelaDadosComplementares: true,
                saveDadosComplementaresSuccess: false,
                msgErroSaveDadosComplementares: ''
            };
        case DadosComplementaresTypes.SEND_DADOS_COMPLEMENTARES_SUCCESS:
            SessionService.setSession({
                retornoDadosComplementares: action.payload.objResponse
            });
            return {
                ...state,
                msgErroSaveDadosComplementares: 'OK',
                saveDadosComplementaresSuccess: true,
                loadingTelaDadosComplementares: false
            };

        case DadosComplementaresTypes.SEND_DADOS_COMPLEMENTARES_FAILURE:
            return {
                ...state,
                msgErroSaveDadosComplementares: action.payload.errorMsg,
                saveDadosComplementaresSuccess: false,
                loadingTelaDadosComplementares: false
            };

        case DadosComplementaresTypes.ERROR_MODAL_ENDERECO_BENEFICIARIOS:
            return { ...state, errorModalEnderecoBeneficiarios: action.payload.error };

        case DadosComplementaresTypes.VERIFICA_PREENCHIMENTO_CAMPOS_BEM: {
            const { inGarantia, idBem } = action.payload;

            if (inGarantia) {
                const nextStateGarantia = {
                    [listaBemValues.PREENCHIMENTO_TODOS_BENS]: verificaPreenchimentoBens(
                        verificaPreenchimentoCamposBem(state.listaBensGarantia, idBem),
                        state.listaBensNaoGarantia
                    ),
                    listaBensGarantia: verificaPreenchimentoCamposBem(state.listaBensGarantia, idBem)
                };

                /** Seta NextState na sessão removendo os polígonos e o KML */
                SessionService.setSession({
                    ...nextStateGarantia,
                    listaBensGarantia: removePoligonoAndKmlFromListBens(nextStateGarantia.listaBensGarantia)
                });

                return {
                    ...state,
                    ...nextStateGarantia
                };
            } else {
                const nextStateNaoGarantia = {
                    [listaBemValues.PREENCHIMENTO_TODOS_BENS]: verificaPreenchimentoBens(
                        state.listaBensGarantia,
                        verificaPreenchimentoCamposBem(state.listaBensNaoGarantia, idBem)
                    ),
                    listaBensNaoGarantia: verificaPreenchimentoCamposBem(state.listaBensNaoGarantia, idBem)
                };

                /** Seta NextState na sessão removendo os polígonos e o KML */
                SessionService.setSession({
                    ...nextStateNaoGarantia,
                    listaBensNaoGarantia: removePoligonoAndKmlFromListBens(nextStateNaoGarantia.listaBensNaoGarantia)
                });

                return {
                    ...state,
                    ...nextStateNaoGarantia
                };
            }
        }
        case DadosComplementaresTypes.VERIFICA_PREENCHIMENTO_TODOS_BENS: {
            const nextState = {
                [listaBemValues.PREENCHIMENTO_TODOS_BENS]: verificaPreenchimentoBens(
                    state.listaBensGarantia,
                    state.listaBensNaoGarantia
                )
            };
            SessionService.setSession(nextState);
            return {
                ...state,
                ...nextState
            };
        }
        case DadosComplementaresTypes.UPDATE_STATE_BUTTON_DESENHAR: {
            if (action.payload.isGarantia) {
                return {
                    ...state,
                    listaBensGarantia: state.listaBensGarantia.map((bem) => {
                        if (bem.id === action.payload[listaBemValues.ID_BEM]) {
                            return {
                                ...bem,
                                [geoFields.DESENHAR_BUTTON]: action.payload.buttonState
                            };
                        }
                        return bem;
                    })
                };
            } else {
                return {
                    ...state,
                    listaBensNaoGarantia: state.listaBensNaoGarantia.map((bem) => {
                        if (bem.id === action.payload[listaBemValues.ID_BEM]) {
                            return {
                                ...bem,
                                [geoFields.DESENHAR_BUTTON]: action.payload.buttonState
                            };
                        }
                        return bem;
                    })
                };
            }
        }
        case DadosComplementaresTypes.VINCULA_BENEFICIARIOS_AOS_BENS: {
            const listaBeneToAdd = action.payload;

            if (listaBeneToAdd && listaBeneToAdd.length > 0) {
                const newListaBensDadosEmGarantia = setBeneficiarioBemFromApi(listaBeneToAdd, state.listaBensGarantia);
                const newListaBensNaoDadosEmGarantia = setBeneficiarioBemFromApi(
                    listaBeneToAdd,
                    state.listaBensNaoGarantia
                );

                setDadosSession(newListaBensDadosEmGarantia, true);
                setDadosSession(newListaBensNaoDadosEmGarantia, false);
                return {
                    ...state,
                    listaBensGarantia: newListaBensDadosEmGarantia,
                    listaBensNaoGarantia: newListaBensNaoDadosEmGarantia
                };
            }
            return state;
        }
        case DadosComplementaresTypes.SET_DADOS_CO_CORRETAGEM: {
            const nextDadosCorretagem = action.payload;
            SessionService.setSession({
                [coCorretagemValues.THIS]: {
                    ...state[coCorretagemValues.THIS],
                    ...nextDadosCorretagem,
                    alreadyLoadedFromApi: true
                }
            });
            return { ...state, listaCorretagem: nextDadosCorretagem };
        }
        case DadosComplementaresTypes.SET_DADOS_POLIGONOS: {
            const dadosPoligonos = action.payload;
            let nextListaBensGarantia = state.listaBensGarantia;
            let nextListaBensNaoGarantia = state.listaBensNaoGarantia;

            for (let i = 0; i < dadosPoligonos.length; i++) {
                if (dadosPoligonos[i][listaBemValues.GARANTIA]) {
                    nextListaBensGarantia = nextListaBensGarantia.map((bem) => {
                        if (bem.id === dadosPoligonos[i].idFront) {
                            return {
                                ...bem,
                                [listaBemValues.POLIGONOS]: dadosPoligonos[i][listaBemValues.POLIGONOS],
                                [listaBemValues.HAS_KML]: dadosPoligonos[i][listaBemValues.HAS_KML]
                            };
                        }
                        return bem;
                    });

                    nextListaBensGarantia = verificaPreenchimentoCamposBem(
                        nextListaBensGarantia,
                        dadosPoligonos[i].idFront
                    );
                } else {
                    nextListaBensNaoGarantia = nextListaBensNaoGarantia.map((bem) => {
                        if (bem.id === dadosPoligonos[i].idFront) {
                            return {
                                ...bem,
                                [listaBemValues.POLIGONOS]: dadosPoligonos[i][listaBemValues.POLIGONOS],
                                [listaBemValues.HAS_KML]: dadosPoligonos[i][listaBemValues.HAS_KML]
                            };
                        }
                        return bem;
                    });

                    nextListaBensNaoGarantia = verificaPreenchimentoCamposBem(
                        nextListaBensNaoGarantia,
                        dadosPoligonos[i].idFront
                    );
                }
            }

            return {
                ...state,
                listaBensGarantia: nextListaBensGarantia,
                listaBensNaoGarantia: nextListaBensNaoGarantia
            };
        }

        case DadosComplementaresTypes.SET_COMBO_PARCELAMENTO: {
            SessionService.setSession({
                ...state,
                [pagamentoValues.COMBO_PARCELAMENTO]: action.payload
            });

            return {
                ...state,
                [pagamentoValues.COMBO_PARCELAMENTO]: action.payload
            };
        }

        default:
            return { ...state };
    }
}

/**
 * Actions
 */
export const Creators = {
    populateDadosComplementaresFromStorage: () => ({
        type: DadosComplementaresTypes.POPULATE_DADOS_COMPLEMENTARES_FROM_STORAGE
    }),
    dadosContatosRequest: (dadosForm) => ({
        type: DadosComplementaresTypes.SEND_DADOS_CONTATO,
        payload: { dadosForm }
    }),
    coCorretagemDadosRequest: (dadosForm) => ({
        type: DadosComplementaresTypes.SEND_DADOS_CO_CORRETAGEM,
        payload: { dadosForm }
    }),
    formaPagamentoDadosRequest: (dadosForm) => ({
        type: DadosComplementaresTypes.SEND_DADOS_FORMAPAGAMENTO,
        payload: { dadosForm }
    }),
    setFormaPagamento: (formaPagamento) => ({
        type: DadosComplementaresTypes.SET_FORMA_PAGAMENTO,
        payload: { formaPagamento }
    }),
    resetFormaPagamento: () => ({
        type: DadosComplementaresTypes.RESET_FORMA_PAGAMENTO
    }),
    setListaErros: (listErros, showModalError) => ({
        type: DadosComplementaresTypes.SET_LISTA_ERROS,
        payload: { listErros, showModalError }
    }),
    removeErros: () => ({
        type: DadosComplementaresTypes.REMOVE_ERROS
    }),
    setEnderecoBem: (idBem, idEndereco, isGarantia) => ({
        type: DadosComplementaresTypes.SET_ENDERECO_BEM,
        payload: { idBem, idEndereco, isGarantia }
    }),
    addBeneficiarioBem: (idBem, idBeneficiario, valueLMI, isGarantia) => ({
        type: DadosComplementaresTypes.SET_BENEFICIARIO_BEM,
        payload: { idBem, idBeneficiario, valueLMI, isGarantia }
    }),
    deleteBeneficiarioBem: (idBem, idBeneficiario, isGarantia) => ({
        type: DadosComplementaresTypes.DELETE_BENEFICIARIO_BEM,
        payload: { idBem, idBeneficiario, isGarantia }
    }),
    setLmiBeneficiario: (idBem, idBeneficiario, valueLMI, isGarantia) => ({
        type: DadosComplementaresTypes.SET_LMI_BENEFICIARIO,
        payload: { idBem, idBeneficiario, valueLMI, isGarantia }
    }),
    setDetalhesEquipamento: (idBem, fabricante, modelo, chassi, isGarantia) => ({
        type: DadosComplementaresTypes.SET_DETALHES_EQUIPAMENTOS,
        payload: { idBem, fabricante, modelo, chassi, isGarantia }
    }),
    updatePolygonsBem: (idBem, isGarantia, poligonos) => ({
        type: DadosComplementaresTypes.UPDATE_POLYGON_BEM,
        payload: {
            idBem,
            isGarantia,
            poligonos
        }
    }),
    addKML: (idBem, isGarantia, kml) => ({
        type: DadosComplementaresTypes.ADD_KML,
        payload: {
            idBem,
            isGarantia,
            kml
        }
    }),
    updateCoordBem: (idBem, isGarantia, coordenadas) => ({
        type: DadosComplementaresTypes.UPDATE_COORD_BEM,
        payload: {
            idBem,
            isGarantia,
            coordenadas
        }
    }),
    sendDadosComplementaresReset: () => ({
        type: DadosComplementaresTypes.SEND_DADOS_COMPLEMENTARES_RESET
    }),
    sendDadosComplementares: (codigoCotacao, objEnvio, listaBeneficiarios, listaEnderecos, dadosCoCorretagem) => ({
        type: DadosComplementaresTypes.SEND_DADOS_COMPLEMENTARES,
        payload: { codigoCotacao, objEnvio, listaBeneficiarios, listaEnderecos, dadosCoCorretagem }
    }),
    sendDadosComplementaresSuccess: (objResponse) => ({
        type: DadosComplementaresTypes.SEND_DADOS_COMPLEMENTARES_SUCCESS,
        payload: { objResponse }
    }),
    sendDadosComplementaresFailure: (errorMsg) => ({
        type: DadosComplementaresTypes.SEND_DADOS_COMPLEMENTARES_FAILURE,
        payload: { errorMsg }
    }),
    addErrorModalEnderecoBeneficarios: (error) => ({
        type: DadosComplementaresTypes.ERROR_MODAL_ENDERECO_BENEFICIARIOS,
        payload: { error }
    }),
    verficaPreenchimentoCamposBem: (idBem, inGarantia) => ({
        type: DadosComplementaresTypes.VERIFICA_PREENCHIMENTO_CAMPOS_BEM,
        payload: { idBem, inGarantia }
    }),
    verificaPreenchimentoTodosBens: () => ({
        type: DadosComplementaresTypes.VERIFICA_PREENCHIMENTO_TODOS_BENS
    }),
    updateStateDesenharButton: (idBem, isGarantia, buttonState) => ({
        type: DadosComplementaresTypes.UPDATE_STATE_BUTTON_DESENHAR,
        payload: {
            idBem,
            isGarantia,
            buttonState
        }
    }),
    reset: () => ({
        type: DadosComplementaresTypes.RESET
    }),
    vinculaBeneficiariosAosBens: (listaBeneficiarios) => ({
        type: DadosComplementaresTypes.VINCULA_BENEFICIARIOS_AOS_BENS,
        payload: listaBeneficiarios
    }),
    setDadosCoCorretagem: (dadosCoCorretagem) => ({
        type: DadosComplementaresTypes.SET_DADOS_CO_CORRETAGEM,
        payload: dadosCoCorretagem
    }),
    setDadosPoligonos: (dadosPoligonos) => ({
        type: DadosComplementaresTypes.SET_DADOS_POLIGONOS,
        payload: dadosPoligonos
    }),

    setDadosFiduciarios: ({ id, numContratoFiduciario, instituicao, cnpj }) => ({
        type: DadosComplementaresTypes.SET_DADOS_FIDUCIARIOS,
        payload: { id, numContratoFiduciario, instituicao, cnpj }
    }),

    setComboParcelamento: (parcelamento) => ({
        type: DadosComplementaresTypes.SET_COMBO_PARCELAMENTO,
        payload: parcelamento
    })
};
